import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getRefreshToken, } from './index'
import router from '../router/index'


axios.defaults.baseURL = process.env.VUE_APP_CURENV;
axios.defaults.timeout = 30000; // 超时时间

//请求拦截器
axios.interceptors.request.use(function(config) {
    // NProgress.start();
    if (localStorage.getItem('user')) {
        let { accessToken } = JSON.parse(localStorage.getItem('user'))
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
}, function(error) {
    // NProgress.start();
    return Promise.reject(error);
});

let isRefreshing = false //标志是否正在刷新,防止多个请求同时进入时多次调用刷新token
let requests = [] //存储待重新发送请求的数组

//响应拦截器即异常处理
axios.interceptors.response.use(function(response) {
    // NProgress.done();
    return response;
}, function(err) {
    // NProgress.done();
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                Message.error('错误请求 400');
                break;
            case 401:
                const { refreshToken } = JSON.parse(localStorage.getItem('user'))
                const { config } = err
                if (!isRefreshing) {
                    isRefreshing = true;
                    return getRefreshToken({ filter: refreshToken }).then(res => {
                        if (res.data.code == 200) {
                            const access_token = res.data.data;
                            config.headers.Authorization = `Bearer ${access_token}`
                            let newInformation = JSON.parse(localStorage.getItem('user'))
                            newInformation.accessToken = res.data.data
                            localStorage.setItem('user', JSON.stringify(newInformation))
                                //重新执行等待队列里的函数，数组里存的是函数
                            requests.forEach((cb) => cb(access_token))
                                //队列执行完后清空数组
                            requests = []
                            return axios(config);
                        } else {
                            router.push('/Login')
                            Message.error('登录超时，请重新登录！');
                        }
                    }).catch(() => {
                        router.push('/Login')
                        Message.error('登录超时，请重新登录！');
                    }).finally(() => {
                        isRefreshing = false
                    })
                } else {
                    return new Promise(resolve => {
                        //数组里是函数
                        requests.push(token => {
                            config.headers.Authorization = `Bearer ${token}`
                            resolve(axios(config))
                        })
                    })
                }
                break;
            case 403:
                Message.error('没有访问权限，拒绝访问');
                break;
            case 404:
                Message.error('请求错误,未找到该资源');
                break;
            case 405:
                Message.error('请求方法未允许');
                break;
            case 408:
                Message.error('请求超时');
                break;
            case 500:
                Message.error('服务器端出错');
                break;
            case 501:
                Message.error('网络未实现');
                break;
            case 502:
                Message.error('网络错误');
                break;
            case 503:
                Message.error('服务不可用');
                break;
            case 504:
                Message.error('网络超时');
                break;
            default:
                Message.error(`连接错误${err.response.msg}`);
        }
    } else {
        Message.error(`连接到服务器失败`);
    }
    return Promise.reject(err);
});
export default axios